// @flow

import React, { Component } from 'react';
import { Card, Button, Dimmer, Icon } from 'semantic-ui-react';
import ResourceSelector from 'shared/components/ResourceSelector/index';
import ResourceImage from 'shared/components/ResourceImage';
import * as ResourceService from 'catalog/services/resources';

type Props = {
  onSelected: (resource: BucketResource) => void,
};

type State = {
  selectorOpen: boolean,
};

const styles = {
  card: {
    maxWidth: '220px',
  },
};

class GalleryImageSelector extends Component {
  props: Props;
  state: State;

  constructor(props: Props) {
    super(props);

    this.state = {
      selectorOpen: false,
    };
  }

  onShowSelector = () => this.setState({ selectorOpen: true });
  onHideSelector = () => this.setState({ selectorOpen: false });

  onResourceSelected = (resource: BucketResource) => {
    this.setState({
      selectorOpen: false,
    });

    this.props.onSelected(ResourceService.createTemplateResource(resource));
  };

  render() {
    const { selectorOpen } = this.state;

    const content = (
      <div>
        <Button
          type="button"
          primary
          icon
          labelPosition="right"
          onClick={this.onShowSelector}
        >
          <Icon name="image" />
          Sélectionner
        </Button>
      </div>
    );

    return (
      <Card centered style={styles.card}>
        <Dimmer.Dimmable
          as={ResourceImage}
          dimmed
          dimmer={{ active: true, content }}
          dimmerProps={{ inverted: true }}
        />
        <ResourceSelector
          open={selectorOpen}
          resourceType="image"
          onResourceSelected={this.onResourceSelected}
          onClose={this.onHideSelector}
        />
      </Card>
    );
  }
}

export default GalleryImageSelector;



// WEBPACK FOOTER //
// ./src/modules/my-space/components/GalleryImageSelector.js